var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamGenesis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_216_478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5406 16.0826C12.2186 14.4536 14.0085 12.7103 15.8067 10.9629V13.5947H18.156V0C17.2942 0.0465426 16.5484 0.088854 15.8026 0.131165C15.5001 4.75157 13.9961 8.50459 10.9466 11.5679C7.90543 14.6228 4.16817 16.0022 0 16.2899V18.8413H23.2605C21.8062 20.3391 20.0536 22.1458 18.2886 23.9652C18.243 23.0766 18.1974 22.1712 18.1477 21.198C17.261 21.253 16.6064 21.2953 15.9227 21.3376V35.0042C16.7473 34.9661 17.406 34.9323 18.0855 34.9027C19.2167 25.078 24.5574 19.7044 34.0041 18.6086V16.091H10.5406V16.0826Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamGenesis);
export default __webpack_public_path__ + "static/media/team_genesis.7e8426b9e80597f9fb605336a777ee1a.svg";
export { ForwardRef as ReactComponent };